<template>
    <nav class="navbar small-nav p-0">
        <!-- Main nav items -->
        <div class="container-fluid p-0">
            <!-- Menu toggler -->
            <i class="hoverable-icon bi-list specific-style" data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" @click="closeDropdown" v-ripple></i>

            <!-- Header -->
            <a class="navbar-brand fw-semi-bold fs-4 py-0 m-0 cursor-pointer specific-style" v-load-page="'/'">
                ExploreMeds
            </a>

            <!-- Search toggler -->
            <i id="searchToggler" class="hoverable-icon bi-search specific-style"
                data-bs-toggle="offcanvas" data-bs-target="#offcanvasSearch" aria-controls="offcanvasSearch"
                v-ripple></i>
        </div>

        <!-- Menu offcanvas -->
        <div class="offcanvas offcanvas-start w-100" data-bs-backdrop="false" tabindex="-1" id="offcanvasNavbar">
            <!-- Offcanvas header -->
            <div class="offcanvas-header border-bottom">
                <!-- Menu toggler -->
                <i class="hoverable-icon bi-arrow-left" data-bs-dismiss="offcanvas" v-ripple></i>
                <!-- Header -->
                <a class="navbar-brand fw-semi-bold fs-4 py-0 m-0 cursor-pointer" v-load-page="'/'">
                    ExploreMeds
                </a>
                <!-- Search toggler -->
                <i class="hoverable-icon bi-search" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSearch"
                    aria-controls="offcanvasSearch" v-ripple></i>
            </div>

            <!-- Menu -->
            <div class="offcanvas-body p-0">
                <!-- Profile item -->
                <div class="nav-item border-bottom">
	                <div v-if="!userLoggedIn" v-load-page="'/survey/anonymous'"
	                     class="dropdown-item d-flex align-items-center cursor-pointer p-big" v-ripple>
		                <i class="cat-nav-icon me-3 bi-list-ul"></i> Start Survey
	                </div>
                    <div v-if="!userLoggedIn" v-load-page="'/login'"
                        class="dropdown-item d-flex align-items-center cursor-pointer p-big" v-ripple>
                        <i class="cat-nav-icon me-3 bi-box-arrow-in-right"></i> Log In
                    </div>
                    <div v-if="!userLoggedIn" v-load-page="'/register'"
                        class="dropdown-item d-flex align-items-center cursor-pointer p-big" v-ripple>
                        <i class="cat-nav-icon me-3 bi-person-add"></i> Register
                    </div>

                    <div v-if="userLoggedIn" class="d-flex align-items-center profile-container" :class="userLoggedIn ? false : 'd-none'">
                        <!-- Profile item -->
                        <img class="rounded-circle avatar me-3" :src="userLoggedIn ? randomAvatar : profilePic"
                             :style="userLoggedIn ? `background-color: ${randomBgColor};` : false" />

                        <div class="d-flex flex-column">
                            <p class="m-0 mb-2 fs-5 fw-medium lh-1">{{ authStore.user.username }}</p>
                            <p class="m-0 lh-1 caption">My Profile</p>
                        </div>

                        <!-- Profile dropdown -->
                        <div class="dropdown dropstart startdown ms-auto">
                            <!-- Dropdown toggler -->
                            <i class="hoverable-icon bi-three-dots-vertical" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" v-ripple></i>

	                        <!-- Options -->
                            <ul class="dropdown-menu">
                                <li v-for="item in profileDropdownItems">
                                    <hr v-if="item.hasOwnProperty('isDivider')" class="dropdown-divider">
                                    <a v-else-if="item.route != '/logout' && (!item.hasOwnProperty('userTypes') || (item.hasOwnProperty('userTypes') && item.userTypes.includes(user_type)))"
                                        class="dropdown-item cursor-pointer" v-load-page="item.route" v-ripple>
                                        <i class="me-3" :class="item.iconClass"></i>
                                        {{ item.label }}
                                        <i class="ms-auto" :class="item.iconRightClass"
                                            v-if="item.hasOwnProperty('iconRightClass')"></i>
                                    </a>
                                    <a v-else-if="item.route == '/logout'" v-load-page="item.route" @click.prevent="authStore.performLogout()" v-ripple
                                        class="dropdown-item cursor-pointer">
                                        <i class="me-3" :class="item.iconClass"></i>
                                        {{ item.label }}
                                        <i class="ms-auto" :class="item.iconRightClass"
                                            v-if="item.hasOwnProperty('iconRightClass')"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Categories dropdown -->
                <ul class="navbar-nav justify-content-end mt-3">
                    <li class="nav-item" v-for="category in categories">
                        <a class="dropdown-item d-flex align-items-center cursor-pointer p-big"
                            v-load-page="category.route" v-ripple>
                            <i class="cat-nav-icon me-3" :class="category.iconClass"></i>
                            {{ category.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <Search v-if="route.name != 'home'"></Search>
    </nav>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useRoute } from 'vue-router';
import { categories, profileDropdownItems } from './navitems';
import profilePic from '../../assets/user.png';
import Search from '../Search/Index.vue';
import { useAuthStore } from "@/stores/auth-store"

const authStore = useAuthStore();

const route = useRoute();
// const isLoggedIn = ref(authStore.isLoggedIn);

// watch(() => authStore.isLoggedIn, (newVal, oldVal) => {
//     isLoggedIn.value = authStore.isLoggedIn;
// });

const userLoggedIn = computed(() => {
    return authStore.isLoggedIn;
});

const user_type = computed(() => {
    return authStore.getUserType;
});

const { width } = useWindowSize();

const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const generateRandomString = (length) => {
    let result = ' ';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
const bgColors = ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#f4a261', '#e76f51'];
const randomBgColor = ref(bgColors[Math.floor(Math.random() * bgColors.length)]);
const randomAvatar = ref('https://anonymous-animals.azurewebsites.net/avatar/' + generateRandomString(5));

const closeDropdown = () => {
    document.body.click()
}
</script>